import { useTranslation } from 'react-i18next';
import Styles from './styles.module.scss';

import logoIcon from '../../../theme/assets/svg/b_logo.svg';
import logoWIcon from '../../../theme/assets/svg/b_logo_w.svg';

import { buildCrossDomainLink } from '../../../utils/buildCrossDomainLink';

const Logo = ({ isLink = true, path = '/', isWhite = false }) => {
    const { i18n } = useTranslation();

    const lang = i18n.language?.startsWith('ru') ? 'ru' : 'en';
    const baseUrl = process.env.REACT_APP_NEXT_URL;

    const href = baseUrl
        ? buildCrossDomainLink({
            baseUrl,
            path,
            lang,
        })
        : path;

    const logoSrc = isWhite ? logoWIcon : logoIcon;

    if (isLink) {
        return (
            <a href={href} className={Styles.logoWrap}>
                <img src={logoSrc} alt="NEXT" />
            </a>
        );
    }

    return (
        <div className={Styles.logoWrap}>
            <img src={logoSrc} alt="NEXT" />
        </div>
    );
};

export default Logo;
